var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "col-12",
      attrs: { id: "personal-details-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          $event.stopPropagation()
          _vm.portal === "broker"
            ? _vm.handleSubmit()
            : _vm.handleInitialSubmit()
        },
        change: _vm.handleFormChange,
      },
    },
    [
      _c("div", { staticClass: "card" }, [
        _c("ul", { staticClass: "list-group list-group-flush" }, [
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "grey-text text-darken-3 col-6 text-left align-self-center",
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t("settings.accountTab.tabs.personalDetails")
                      ) +
                      "\n          "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "list-group-item" }, [
            _c("div", { staticClass: "settings-container mx-0 col-lg-10" }, [
              _c("div", { staticClass: "row moregage-form" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-md-12 col-12 pb-lg-0 pb-3" },
                  [
                    _c("material-input", {
                      attrs: {
                        label: _vm.$t("account.givenName"),
                        placeholder: _vm.$t("account.givenName"),
                        "required-indicator": "",
                      },
                      model: {
                        value: _vm.givenName,
                        callback: function ($$v) {
                          _vm.givenName = $$v
                        },
                        expression: "givenName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-md-12 col-12 pb-lg-0 pb-3" },
                  [
                    _c("material-input", {
                      attrs: {
                        label: _vm.$t("account.middleName"),
                        placeholder: _vm.$t("account.middleName"),
                      },
                      model: {
                        value: _vm.middleName,
                        callback: function ($$v) {
                          _vm.middleName = $$v
                        },
                        expression: "middleName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-4 col-md-12 col-12 pb-lg-0 pb-3" },
                  [
                    _c("material-input", {
                      attrs: {
                        label: _vm.$t("account.familyName"),
                        placeholder: _vm.$t("account.familyName"),
                        "required-indicator": "",
                      },
                      model: {
                        value: _vm.familyName,
                        callback: function ($$v) {
                          _vm.familyName = $$v
                        },
                        expression: "familyName",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row moregage-form" }, [
                _c("div", { staticClass: "col-12 pb-lg-0 pb-3" }, [
                  _c("div", { staticClass: "form-group-material mb-1" }, [
                    _c(
                      "div",
                      {
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "right",
                          title: "You're not allowed to change your email",
                        },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.email,
                              expression: "email",
                            },
                          ],
                          staticClass: "form-control form form-control-filled",
                          attrs: {
                            id: "email",
                            required: "",
                            disabled: "",
                            type: "text",
                            name: "email",
                            placeholder: _vm.$t("account.email"),
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "bar" }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "title text-light-gray mb-2 mb-lg-0",
                            attrs: { for: "email" },
                          },
                          [_vm._v(_vm._s(_vm.$t("account.email")))]
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row moregage-form" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6 col-12 pb-lg-0 pb-3" },
                  [
                    _c(
                      "material-input",
                      {
                        attrs: {
                          label: _vm.$t("account.phoneNumber"),
                          "required-indicator": "",
                        },
                        model: {
                          value: _vm.phoneNumber,
                          callback: function ($$v) {
                            _vm.phoneNumber = $$v
                          },
                          expression: "phoneNumber",
                        },
                      },
                      [
                        _c("phone-input", {
                          staticClass: "material-input form-control",
                          attrs: {
                            id: "phone",
                            value: _vm.phoneNumber,
                            required: "",
                            title: "Please, enter a valid phone number",
                            "max-length": "14",
                            name: "phoneNumber",
                            placeholder: _vm.$t("account.phoneNumber"),
                            "emit-value": true,
                          },
                          on: {
                            change: function (val) {
                              return (_vm.phoneNumber = val)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6 col-12 pb-lg-0 pb-3" },
                  [
                    _c(
                      "material-input",
                      {
                        attrs: { label: _vm.$t("account.altPhoneNumber") },
                        model: {
                          value: _vm.altPhoneNumber,
                          callback: function ($$v) {
                            _vm.altPhoneNumber = $$v
                          },
                          expression: "altPhoneNumber",
                        },
                      },
                      [
                        _c("phone-input", {
                          staticClass: "material-input form-control",
                          attrs: {
                            id: "alt-phone",
                            value: _vm.altPhoneNumber,
                            title: _vm.$t("account.form.validPhoneNumber"),
                            "max-length": "14",
                            name: "phoneNumber",
                            placeholder: _vm.$t("account.altPhoneNumber"),
                            "emit-value": true,
                          },
                          on: {
                            change: function (val) {
                              return (_vm.altPhoneNumber = val)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row moregage-form" }, [
                _c("div", { staticClass: "col-12 pb-lg-0 pb-3" }, [
                  _c("div", { staticClass: "form-group-material mb-1" }, [
                    _c("select", {
                      staticClass:
                        "material-input select-field form-control-filled",
                      attrs: {
                        id: "timezone-select",
                        required: "",
                        name: "timezone",
                      },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "bar" }),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "title text-light-gray mb-2 mb-lg-0" },
                      [
                        _vm._v(_vm._s(_vm.$t("account.timezone"))),
                        _c("input-required-indicator"),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "p",
                    { staticClass: "small text-light-gray font-italic mb-0" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("settings.accountTab.changeTimezoneMessage")
                          ) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _vm.portal === "broker"
                ? _c("div", { staticClass: "row moregage-form no-gutters" }, [
                    _c(
                      "article",
                      { attrs: { id: "personal-address" } },
                      [
                        _c("address-section", {
                          model: {
                            value: _vm.address,
                            callback: function ($$v) {
                              _vm.address = $$v
                            },
                            expression: "address",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }